
const weatherConditionsGroup = {

    'Sunny': {
        meme: 'sun',
        sound: 'sun',
        background: 'sun-background'
      },
      'Clear': {
        meme: 'sun',
        sound: 'sun',
        background: 'sun-background'
      },
      'Partly cloudy': {
        meme: 'partlycloudy',
        sound: 'partlycloudy',
        background: 'cloudy-background'
      },
      'Cloudy': {
        meme: 'cloudy',
        sound: 'cloudy',
        background: 'cloudy-background'
      },
      'Overcast': {
        meme: 'cloudy',
        sound: 'cloudy',
        background: 'cloudy-background'
      },
      'Patchy rain possible': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Moderate or heavy freezing rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Light freezing rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Heavy rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Heavy rain at times': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Moderate rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Moderate rain at times': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Light rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Light rain shower': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Moderate or heavy rain shower': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Patchy light rain': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Torrential rain shower': {
        meme: 'rain',
        sound: 'rain',
        background: 'rain-background'
      },
      'Wind': {
        meme: 'wind',
        sound: 'wind',
        background: 'cloudy-background'
      },
      'Blowing snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy snow possible': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy sleet possible': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Blizzard': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Light snow showers': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Moderate or heavy snow showers': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy light snow with thunder': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Moderate or heavy snow with thunder': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Moderate or heavy sleet': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy light snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Light snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy moderate snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Moderate snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy heavy snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Heavy snow': {
        meme: 'snow',
        sound: 'snow',
        background: 'rain-background'
        },
      'Patchy freezing drizzle possible': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Freezing drizzle': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Light sleet': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Light sleet showers': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Moderate or heavy sleet showers': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Light showers of ice pellets': {
        meme: 'freezing',
        sound: 'wind',
        background: 'rain-background'
        },
      'Ice pellets': {
        meme: 'verglas',
        sound: 'wind',
        background: 'rain-background'
        },
      'Thundery outbreaks possible': {
        meme: 'thunderstorm',
        sound: 'thunderstorm',
        background: 'rain-background'
        },
      'Patchy light rain with thunder': {
        meme: 'thunderstorm',
        sound: 'thunderstorm',
        background: 'rain-background'
        },
      'Moderate or heavy rain with thunder': {
        meme: 'thunderstorm',
        sound: 'thunderstorm',
        background: 'rain-background'
        },
      'Heatwave': {
        meme: 'heatwave',
        sound: 'heatwave',
        background: 'sun-background'
        },
      'Fog': {
        meme: 'fog',
        sound: 'fog',
        background: 'rain-background'
        },
      'Mist': {
        meme: 'fog',
        sound: 'fog',
        background: 'rain-background'
        },
      'Freezing fog': {
        meme: 'fog',
        sound: 'fog',
        background: 'rain-background'
        },
      'Patchy light drizzle': {
        meme: 'fog',
        sound: 'fog',
        background: 'rain-background'
        },
      'Light drizzle': {
        meme: 'fog',
        sound: 'fog',
        background: 'rain-background'
        },
};

export default weatherConditionsGroup;
